import React, { useState } from "react";
import Dropdown from "../../../../parts/dropdown";
import { SearchDropdown } from "../../../../parts/inputs/search-dropdown";
const options = [
  {
    text: "Option one",
    value: "0",
  },
  {
    text: "Option two",
    value: "0",
  },
  {
    text: "Option three",
    value: "0",
  },
  {
    text: "Option four",
    value: "0",
  },
  {
    text: "Option five",
    value: "0",
  },
];
const searchOptions = [
  { movementLabel: "Option 1" },
  { movementLabel: "Option 2" },
  { movementLabel: "Option 3" },
  { movementLabel: "Option 4" },
  { movementLabel: "Option 5" },
  { movementLabel: "Option 6" },
  { movementLabel: "Option 7" },
  { movementLabel: "Option 8" },
  { movementLabel: "Option 9" },
  { movementLabel: "Option 10" },
];
const Dropdowns = () => {
  const [selectedOption, setSelectedOption] = useState(options[0]);
  const [searchOption, setSearchOption] = useState(searchOptions[0]);
  return (
    <div className="flex items-center gap-4 flex-wrap">
      <Dropdown
        summaryText={selectedOption.text}
        options={options}
        onSelectFn={(receivedOption) => {
          console.log(receivedOption);
          setSelectedOption(receivedOption);
        }}
        fullOption={true}
      />

      <SearchDropdown
        options={searchOptions}
        handleChange={setSearchOption}
        valueKey="movementLabel"
        placeholder={searchOption.movementLabel}
      />
    </div>
  );
};

export default Dropdowns;
